import { Translation, Trans } from 'react-i18next';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { ColumnProps, FollowButton } from '@/components';
import { formatDate, numFormat, formatRanking } from '@/utils';

import { UserCard } from '@/components/UserCard';

import { TopTokens } from '@/components/Stats';
import { useCurrentAddressInfo } from '@/hooks';
import style from './index.module.scss';
import { Follower, FollowListFrom } from './hook';
import { getNetWorthOrderKey } from './utils';

const FollowButtonWrap = (props: Parameters<typeof FollowButton>[0]) => {
  const { address } = useCurrentAddressInfo();
  if (address === props.address) {
    return null;
  }
  return <FollowButton {...props}></FollowButton>;
};

export const getColumns = ({
  refetch,
  isFollowing,
  from,
}: {
  refetch: any;
  from: FollowListFrom;
  isFollowing?: boolean;
}): Array<ColumnProps<Follower>> => [
  {
    title: (
      <span style={{ paddingLeft: 26 }}>
        <Translation>{t => t('FollowList_columns.1kpnv')}</Translation>
      </span>
    ),
    key: 'id',
    width: '200px',
    render: ({ cellData, row }) => {
      return (
        <UserCard
          data={row.desc}
          onMemoChange={() => refetch()}
          relaction={row.relation === 'friend' ? 'friend' : undefined}
        />
      );
    },
    skeleton: (
      <div className={style.innerCell}>
        <Skeleton width={104} />
      </div>
    ),
  },
  {
    width: '80px',
    key: 'follower_count',
    title: <Translation>{t => t('FollowList_columns.19t454l')}</Translation>,
    render({ row }) {
      return <div className={style.followCount}>{numFormat(row.follower_count, 0)}</div>;
    },
  },
  {
    title: <Translation>{t => t('FollowList_columns.q6o2ej')}</Translation>,
    width: '90px',
    key: getNetWorthOrderKey(from, isFollowing),
    sortable: !['collection', 'token'].includes(from),
    forceSort: true,
    render: ({ row }) => {
      return <div className={style.netWorth}>{formatRanking(row?.stats?.usd_value)}</div>;
    },
    skeleton: <Skeleton width={104} />,
  },

  {
    title: <Translation>{t => t('FollowList_columns.lga8rp')}</Translation>,
    width: '253px',
    key: 'top_tokens',
    render: ({ row }) => {
      return (
        <TopTokens
          data={[...(row?.stats?.top_coins || []), ...(row?.stats?.top_tokens || [])]}></TopTokens>
      );
    },
    skeleton: (
      <div className={style.innerCell}>
        <Skeleton width={104} />
      </div>
    ),
  },
  // {
  //   title: <Translation>{t => t('FollowList_columns.9kxv3k')}</Translation>,
  //   width: '253px',
  //   key: 'top_protocols',
  //   render: ({ row }) => {
  //     return <TopProtocols data={row?.stats?.top_protocols}></TopProtocols>;
  //   },
  //   skeleton: (
  //     <div className={style.innerCell}>
  //       <Skeleton width={104} />
  //     </div>
  //   ),
  // },
  // {
  //   title: <Translation>{t => t('FollowList_columns.top-nft-collections')}</Translation>,
  //   width: '200px',
  //   key: 'top_NFT',
  //   render: ({ row }) => {
  //     return (
  //       <div>
  //         <TopCollections data={row?.stats?.top_collections} />
  //       </div>
  //     );
  //   },
  //   skeleton: (
  //     <div className={style.innerCell}>
  //       <Skeleton width={104} />
  //     </div>
  //   ),
  // },
  ['collection', 'user', 'token'].includes(from) && !isFollowing
    ? {
        title: <Translation>{t => t('FollowList_columns.1i2kc0f')}</Translation>,
        width: '98px',
        key: 'create_at',
        sortable: true,
        forceSort: true,
        render: ({ row }) => {
          return <div>{formFollowDate(row.create_at * 1000)}</div>;
        },
        skeleton: (
          <div className={style.innerCell}>
            <Skeleton width={104} />
          </div>
        ),
      }
    : {},
  {
    title: '',
    width: '25px',
    key: 'follow',
    render: ({ row }) => {
      return <FollowButtonWrap address={row.id} type="icon" userInfo={row as any} />;
    },
  },
];
const formFollowDate = (timeStamp: number) => {
  const currentTimestamp = Math.floor(Date.now());
  const timeDifference = currentTimestamp - timeStamp;
  const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  if (daysDifference === 0) {
    return <Translation>{t => t('FollowList_columns.today')}</Translation>;
  } else if (daysDifference === 1) {
    return <Trans i18nKey="FollowList_columns.yesterday"></Trans>;
  } else {
    return formatDate(timeStamp, 'YYYY/MM/DD');
  }
};
